import React from 'react';

import { Box, Grid, Paper } from '@mui/material';
import { Details, Review } from './components';
import {
  homeDetailsWrapperSx,
  homeDetailsPaperSx,
  homeDetailsColumnSx
} from '../../../Common/components/Styles/InputStyles';

import {
  homeDetailsColumnWrapperSx,
  homeDetailsGridItemSx,
  homeDetailsGridSx,
  homeDetailsPaperWrapperSx,
  homeDetailsRootSx
} from './HomeDetailsStyles';

const HomeDetails = () => {
  return (
    <Box sx={{ ...homeDetailsWrapperSx, ...homeDetailsRootSx }}>
      <Paper
        elevation={0}
        sx={{ ...homeDetailsPaperSx, ...homeDetailsPaperWrapperSx }}>
        <Grid
          container
          columnSpacing={1}
          alignItems="stretch"
          sx={homeDetailsGridSx}>
          <Grid size={{ xs: 12, md: 8 }} sx={homeDetailsGridItemSx}>
            <Box sx={{ ...homeDetailsColumnSx, ...homeDetailsColumnWrapperSx }}>
              <Details />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }} sx={homeDetailsGridItemSx}>
            <Box sx={{ ...homeDetailsColumnSx, ...homeDetailsColumnWrapperSx }}>
              <Review />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default HomeDetails;
